import api from "../../../api/axios";

const BASE = "/bases_estaleiro/classes";

export async function listarClassesEstaleiro({ q = "", ativo, limit = 100, offset = 0 } = {}) {
  const { data } = await api.get(`${BASE}/listar`, { params: { q, ativo, limit, offset } });
  return Array.isArray(data?.data) ? data.data : [];
}

export async function cadastrarClasseEstaleiro(payload) {
  const { data } = await api.post(`${BASE}/cadastrar`, payload);
  return data?.data || null;
}

export async function editarClasseEstaleiro(id, payload) {
  const { data } = await api.put(`${BASE}/editar/${id}`, payload);
  return data?.data || null;
}

export async function alterarStatusClasseEstaleiro(id, ativo) {
  const { data } = await api.patch(`${BASE}/alterar-ativo/${id}`, { ativo: Number(ativo) ? 1 : 0 });
  return data?.data || null;
}

export async function excluirClasseEstaleiro(id) {
  const { data } = await api.delete(`${BASE}/excluir/${id}`);
  return data?.data || null;
}
